import { Spinner as ChakraSpinner, SpinnerProps } from '@chakra-ui/react';

export function AppSpinner(props: SpinnerProps) {
  return <ChakraSpinner fontSize="0px" {...props} />;
}
